const { h, render, Component } = require('preact');

class TrendingArticlesHeaderView extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <p> {I18n.translate("js.modules.web_2018.no_contextual_search_results_found_message")} </p>
        <p class="frequently-viewed-topics-header">
          {I18n.translate("js.modules.web_2018.frequently_viewed_topics")}
        </p>
      </div>
    );
  }
}
module.exports = TrendingArticlesHeaderView
